// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1mVyh","productName":"Table_productName__5XYCg"};